import type { AppRouter } from "@repo/swarved-backend/router";
import { createTRPCReact, type CreateTRPCReact } from "@trpc/react-query";
import type { inferRouterOutputs } from "@trpc/server";

export type RouterOutputs = inferRouterOutputs<AppRouter>;

export const trpc: CreateTRPCReact<AppRouter, unknown> =
  createTRPCReact<AppRouter>();
